import { createContext, useContext, useEffect, useReducer } from 'react';
import { questionsAndAnswerEffects, questionsAndAnswersHandlers, questionsAndAnswersInitialState, questionsAndAnswersReducer } from '../reducers/QuestionsAndAnswersReducer';
import { ratingHandlers, ratingInitialState, ratingReducer } from '../reducers/RatingReducer';
import { surverReducer, surveyHandlers, surveyInitialState } from '../reducers/SurverReducer';
import { PapsContext } from './PapsContext';
import { CurrentSettingsContext } from './SettingsDataContext';
import { useGetData } from './useHelpers/useGetData';

/** Global VideoConferences (Icon, Image, PDF) for the Event taken from the database */
export const QuestionsAndAnswersContext = createContext();
export const SurveyContext = createContext();
export const RatingContext = createContext();

/** This will get the qAndA, ratings and survey */
const AppAdminProvider = (props) => {

  const { getEventData } = useGetData()

  // papsContext
  const papsContext = useContext(PapsContext)
  const { paps_state } = papsContext ?? {}

  const currentSettingsContext = useContext(CurrentSettingsContext)
  const { currentSettings_state } = currentSettingsContext ?? {}

  // pageContext 
  const { settingsDocName, pathViews } = paps_state ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appQuestionsAndAnswers, appRating, appSurvey } = aps_global ?? {}
  const { allowQuestionsAndAnswers } = appQuestionsAndAnswers ?? {}
  const { allowRating } = appRating ?? {}
  const { allowSurvey } = appSurvey ?? {}

  // questionsAndAnswers_state
  const init_state_qna = { pathViews, allowQuestionsAndAnswers }
  const [questionsAndAnswers_state, questionsAndAnswersDispatch] = useReducer(questionsAndAnswersReducer, questionsAndAnswersInitialState(init_state_qna));
  const questionsAndAnswers_handlers = questionsAndAnswersHandlers(questionsAndAnswersDispatch, questionsAndAnswers_state)
  const questionsAndAnwers_effects = questionsAndAnswerEffects(questionsAndAnswersDispatch)

  const init_state_rating = { pathViews, allowRating }
  const [rating_state, ratingDispatch] = useReducer(ratingReducer, ratingInitialState(init_state_rating));
  const rating_handlers = ratingHandlers(ratingDispatch, rating_state)

  // survey_state
  const init_state_survey = { pathViews, allowSurvey }
  const [survey_state, surveyDispatch] = useReducer(surverReducer, surveyInitialState(init_state_survey));
  const survey_handlers = surveyHandlers(surveyDispatch, survey_state)
  const { activeSurvey } = survey_state ?? {}

  useEffect(
    () => {
      getEventData({ pathViews, items: ['_questionsAndAnswers'], callback: questionsAndAnswers_handlers.handleSetQuestionsAndAnswers })
      getEventData({ pathViews, items: ['_ratings'], callback: rating_handlers.handleResponse_rating })
      getEventData({ pathViews, items: ['_survey'], callback: survey_handlers.handleResponse_survey })
    },
    // eslint-disable-next-line
    [settingsDocName] // does not re-rednder unless uivi has changed
  )

  const providerContext = () => {
    return <QuestionsAndAnswersContext.Provider value={{ questionsAndAnswers_state, questionsAndAnswers_handlers, questionsAndAnwers_effects }}>
      <RatingContext.Provider value={{ rating_state, rating_handlers }}>
        <SurveyContext.Provider value={{ survey_state, survey_handlers }}>
          {props.children}
        </SurveyContext.Provider>
      </RatingContext.Provider>
    </QuestionsAndAnswersContext.Provider>
  }

  return providerContext()

}

export default AppAdminProvider